import { DepositDashboard } from "#/ui/Deposit"

export default function DepositPage() {
  return <DepositDashboard />
}
